import { render, staticRenderFns } from "./ProductSetMater.vue?vue&type=template&id=3d713c58&scoped=true&"
import script from "./ProductSetMater.vue?vue&type=script&lang=js&"
export * from "./ProductSetMater.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetMater.vue?vue&type=style&index=0&id=3d713c58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d713c58",
  null
  
)

export default component.exports